import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

const IconMenu = ({
  anchorEl,
  open,
  onClose,
  menuItems,
  anchorOrigin = { horizontal: "right", vertical: "bottom" },
  transformOrigin = { horizontal: "right", vertical: "top" },
  menuProps = {},
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: "visible",
          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
          mt: 1.5,
          "& .MuiAvatar-root": {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          "&:before": {
            content: '""',
            display: "block",
            position: "absolute",
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: "background.paper",
            transform: "translateY(-50%) rotate(45deg)",
            zIndex: 0,
          },
          ...menuProps.sx,
        },
        ...menuProps,
      }}
    >
      {menuItems.map((item, index) => (
        <MenuItem key={index} onClick={item.onClick || onClose}>
          {item.icon && (
            <ListItemIcon>
              {React.cloneElement(item.icon, { fontSize: "small" })}
            </ListItemIcon>
          )}
          <ListItemText>{item.label}</ListItemText>
        </MenuItem>
      ))}
    </Menu>
  );
};

export default IconMenu;
